module.exports = __webpack_public_path__ + "static/fonts/aeonik-bold.25a24c90.woff2";